import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Switch, Tooltip } from 'antd';

import InputWithSearchModal from '../../components/InputWithSearchModal'

import UserFilter from '../UserFilter'
import UserSelector from '../UserSelector'
import CRUDE_City from '../../../objects/City/crude'
import REDUX_City from '../../../objects/City/reducer'
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import User from '../../../common/User';
const { TextArea } = Input;
const { Option } = Select;

export default function AddUserInfo(props) {
    const { auth, form, object } = props;
    const dispatch = useDispatch();
    const [showUserFields, setShowUserFields] = useState(false);

    const city = useSelector(REDUX_City.selector.array);
    useEffect(() => {
        CRUDE_City.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_City.actions.setArray(data));
            }
        }, 'model', 's-name=ASC');
    }, []);
    useEffect(() => {
        if (form) {
            form.resetFields();
            form.setFieldsValue(object);
        }
    }, [object]);

    const cityOptions = city.map((i) => <Option key={i.ID} value={i.ID}>{i.name}</Option>);

    const cityID = Form.useWatch('cityID', form);
    const vk = Form.useWatch('vk', form);
    const cityVnutrID = Form.useWatch('cityVnutrID', form);
    const vkVnutr = Form.useWatch('vkVnutr', form);
    const user = Form.useWatch('user', form);

    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item
                    preserve={(user) ? "true" : "false"}
                    hidden={!!user}
                    name={"user"}
                    label={"Пользователь"}
                    rules={[{ required: true, message: 'Укажите пользователя!' }]}
                >
                    <InputWithSearchModal valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{}}
                        searchForm={UserFilter}
                        selectForm={UserSelector} />
                </Form.Item>
                {(user) && <div style={{ padding: "5px 0px" }}>
                    <User item={user} />
                </div>}
                {/* {(!cityID || !vk) && <div className='bg bg-grey' style={{ padding: "2px", marginBottom: "5px", textAlign: "end" }}>
                    <Tooltip title="Показать пользовательские поля">
                        <Switch
                            onChange={(checked) => setShowUserFields(checked)}
                            size="small"
                            checkedChildren={<UserOutlined />}
                            unCheckedChildren={<SettingOutlined />}
                        />
                    </Tooltip>
                </div>} */}
                {/* {(cityID || vk || showUserFields) && <div className='bg bg-blue' style={{ padding: "5px 7px", marginBottom: "5px", textAlign: "left" }}>
                    {(cityID || showUserFields) && <Form.Item label="Город"
                        name="cityID"
                        tooltip={{ title: 'Пользовательское поле', icon: <UserOutlined style={{ color: "#1890ff", fontSize: "12px" }} /> }}
                        rules={[{ required: false, message: 'Пожалуйста, укажите город!' }]}
                    >
                        <Select
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {cityOptions}
                        </Select>
                    </Form.Item>}
                    {(vk || showUserFields) && <Form.Item
                        name={"vk"}
                        tooltip={{ title: 'Пользовательское поле', icon: <UserOutlined style={{ color: "#1890ff", fontSize: "12px" }} /> }}
                        label={"VK"}
                        rules={[{ required: false, message: 'Укажите VK!' }]}
                    >
                        <Input />
                    </Form.Item>}
                </div>} */}
                <div className='bg bg-grey' style={{ padding: "5px 7px", marginBottom: "5px", textAlign: "left" }}>
                    <Form.Item label="Город"
                        name="cityVnutrID"
                        tooltip={{ title: 'Поле для внутреннего пользования!', icon: <SettingOutlined style={{ color: "orange", fontSize: "12px" }} /> }}
                        rules={[{ required: false, message: 'Пожалуйста, укажите город!' }]}
                    >
                        <Select
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {cityOptions}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name={"vkVnutr"}
                        tooltip={{ title: 'Поле для внутреннего пользования!', icon: <SettingOutlined style={{ color: "orange", fontSize: "12px" }} /> }}
                        label={"VK"}
                        rules={[{ required: false, message: 'Укажите VK!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={"kommentarii"}
                        label={"Комментарий"}
                        rules={[{ required: false, message: 'Укажите комментарий!' }]}
                    >
                        <TextArea rows={3} />
                    </Form.Item>
                </div>
            </Form>
        </>
    );
}
